// extracted by mini-css-extract-plugin
export var discard = "_3c-3";
export var muiTooltipTooltip = "_3c-5";
export var notificationBar = "_3c-2";
export var saveButtonHoverSlotWrapper = "_3c-4";
export var show = "_3c-1";
export var spacer = "_3c-0";